import { Parser } from "@siteimprove/alfa-parser";
import { Component } from "./component.js";
import { Token } from "./token.js";
const { either, pair, left, map, takeUntil } = Parser;
/**
 * {@link https://drafts.csswg.org/css-syntax/#simple-block}
 *
 * @public
 */
export class Block {
    static of(token, value) {
        return new Block(token, Array.from(value));
    }
    _token;
    _value;
    constructor(token, value) {
        this._token = token;
        this._value = value;
    }
    get token() {
        return this._token;
    }
    get value() {
        return this._value;
    }
    *[Symbol.iterator]() {
        // <open>
        yield this._token;
        // <value>
        yield* this._value;
        // <close>
        yield this._token.mirror;
    }
    equals(value) {
        return (value instanceof Block &&
            value._token.equals(this._token) &&
            value._value.length === this._value.length &&
            value._value.every((token, i) => token.equals(this._value[i])));
    }
    toJSON() {
        return {
            token: this._token.toJSON(),
            value: this._value.map((token) => token.toJSON()),
        };
    }
    toString() {
        return (this._token.toString() +
            this._value.join("") +
            this._token.mirror.toString());
    }
}
/**
 * @public
 */
(function (Block) {
    /**
     * Consumes components delimited by parentheses, square brackets or curly
     * brackets.
     *
     * @remarks
     * The compiler doesn't check if the delimiter types match, that needs to be
     * ensured by the caller of the function.
     */
    function consumeDelimited(open, closed) {
        return map(left(pair(open, 
        // eta expansion is necessary for `this` binding to resolve correctly
        takeUntil((input) => Component.consume(input), closed)), closed), ([open, components]) => Block.of(open, components.flatMap((component) => [...component])));
    }
    const consumeParentheses = consumeDelimited(Token.parseOpenParenthesis, Token.parseCloseParenthesis);
    const consumeSquareBrackets = consumeDelimited(Token.parseOpenSquareBracket, Token.parseCloseSquareBracket);
    const consumeCurlyBracket = consumeDelimited(Token.parseOpenCurlyBracket, Token.parseCloseCurlyBracket);
    /**
     * {@link https://drafts.csswg.org/css-syntax/#consume-a-simple-block}
     */
    Block.consume = either(consumeParentheses, consumeSquareBrackets, consumeCurlyBracket);
})(Block || (Block = {}));
//# sourceMappingURL=block.js.map